function toMinutes(value) {
  const match = String(value || "").match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return 0;
  return Number(match[1]) * 60 + Number(match[2]);
}

function endOf(activity) {
  const start = toMinutes(activity.startTime);
  const end = toMinutes(activity.endTime);
  return end > start ? end : start + 1;
}

/**
 * Retourne un rang par heure de démarrage. Une activité démarrée avant le rang
 * reste présente si elle chevauche ce nouveau créneau, sans changer sa hauteur.
 */
export function buildOverlapRows(activities) {
  const sorted = [...(activities || [])]
    .map((activity) => ({ activity, start: toMinutes(activity.startTime), end: endOf(activity) }))
    .sort((left, right) => left.start - right.start || left.end - right.end);
  const starts = [...new Set(sorted.map((entry) => entry.start))];

  return starts.map((start) => {
    const source = sorted.find((entry) => entry.start === start)?.activity;
    const items = sorted
      .filter((entry) => entry.start <= start && entry.end > start)
      .map((entry) => ({
        activity: entry.activity,
        isContinuation: entry.start < start,
      }));
    return {
      start,
      startTime: source?.startTime || "--:--",
      items,
    };
  }).filter((row) => row.items.length);
}